import { atom, useAtom } from "jotai";

const loginLimitModalVisible = atom(false);
const loginLimitNum = atom<string | number>(1);

export const useShowLoginLimitModal = () => {
  const [showLoginLimitModal, setShowLoginLimitModal] = useAtom(loginLimitModalVisible);
  const [loginLimitNumber, setLoginLimitNumber] = useAtom(loginLimitNum);
  return { showLoginLimitModal, setShowLoginLimitModal, loginLimitNumber, setLoginLimitNumber };
};
